<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_acc_item_type_additional_item.edit_title') + (additionalItem ? (` : ${additionalItem.name}`) : '')"
           fixed-tabs>
    <template #content>
      <v-container class="edit-item-type-content pa-0" fluid v-if="additionalItem">
        <v-tabs fixed-tabs
                v-model="tabIndex">
          <v-tab>{{ $t('register.basic_info') }}</v-tab>
          <v-tab-item>
            <v-container class="overflow-y-scroll" fluid>
              <v-form ref="additionalItemForm">
                <v-text-field outlined
                              :label="$t('admin_acc_item_type_additional_item.name_en')"
                              v-model="additionalItem.name_en"
                              :rules="requiredRules"></v-text-field>
                <v-text-field outlined
                              :label="$t('admin_acc_item_type_additional_item.name_zh')"
                              v-model="additionalItem.name_zh"
                              :rules="requiredRules"></v-text-field>
                <v-text-field outlined
                              type="number"
                              min="0"
                              :label="$t('admin_acc_item_type_additional_item.price')"
                              v-model="additionalItem.price"
                              :rules="requiredRules"></v-text-field>
                <v-text-field outlined
                              type="number"
                              :label="$t('admin_acc_item_type_additional_item.max_per_booking')"
                              v-model="additionalItem.max_per_booking"
                              :rules="requiredRules"></v-text-field>
                <v-input hide-details="auto"
                         v-model="additionalItem.icon"
                         :rules="requiredRules">
                  <v-container fluid class="flex-column">
                    <legend class="v-label theme--light">{{ $t('admin_acc_item_type_additional_item.icon') }}</legend>
                    <PhotoPreviewInput v-model="additionalItem.icon"
                                       file-name="item-type-icon"></PhotoPreviewInput>
                    <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG</small>
                  </v-container>
                </v-input>
              </v-form>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.additionalItemForm.validate() && saveAdditionalItem()"
               v-if="tabIndex === 0">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";
import TinyMceEditor from "@/components/TinyMceEditor";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";

export default {
  name: 'EditItemTypeAdditionalItemModal',
  components: {PhotoPreviewInput, TinyMceEditor, BGModal},
  props: {
    additionalItemId: String,
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);
    const cancel = function () {
      emit('cancel');
    };

    const tabIndex = ref(0);

    // Init
    watch(() => props.shown, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          getAdditionalItem()
        }
      }

      tabIndex.value = 0;
    });

    const additionalItem = ref(null);
    const getAdditionalItem = function () {
      root.$callAPI('room/admin/item_type/additional_item/', {additional_item_id: props.additionalItemId}, function (response) {
        additionalItem.value = response.body.additional_item;
      });
    }

    // Info
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const saveAdditionalItem = async function () {
      root.$callAPI('room/admin/item_type/additional_item/set/', {
        ...additionalItem.value,
        additional_item_id: props.additionalItemId,
        item_type_id: additionalItem.value.item_type,
        icon: additionalItem.value.icon instanceof File ? await root.$convertFileToBase64(additionalItem.value.icon) : additionalItem.value.icon,
      }, () => {
        root.$showAlertMessage('Info Saved');
      })
    }


    return {
      dialogShown,
      cancel,

      tabIndex,

      additionalItem,

      // Info
      requiredRules,
      saveAdditionalItem,
    }
  }
}
</script>

<style lang="less">
.edit-item-type-content {
  display: flex;
  height: 100%;
}
</style>
